import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CBMError } from 'app/models';
import { OAuthService } from 'app/services';

@Component({
  selector: 'app-login-keycloak',
  templateUrl: './logout-keycloak.component.html',
  styleUrls: ['./logout-keycloak.component.scss']
})
export class LogoutKeycloakComponent implements OnInit {
  public pageTitle = 'NDW - CBM';
  public errorMessages: CBMError[] = [];

  constructor(private readonly router: Router, private readonly oauthService: OAuthService) {}

  ngOnInit() {
    this.pageTitle = `${this.pageTitle} - Uitloggen`;
    this.oauthService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/logout-keycloak/logout-keycloak.component.ts